export default {
    name: 'Browser',
    dimensions: { width: 20, height: 21 },
    content: `
    <rect x="1" y="1.5" width="18" height="18" rx="2" fill="none" stroke="currentColor" stroke-width="2"/>
    <circle cx="5" cy="5.5" r="1" fill="currentColor" stroke="none"/>
    <circle cx="8" cy="5.5" r="1" fill="currentColor" stroke="none"/>
    <circle cx="11" cy="5.5" r="1" fill="currentColor" stroke="none"/>
  `
};
